import { Fragment, useEffect, useState } from "react";
import WhyLanding from "./whyLanding/WhyLanding";
import PageLayout from "../../layouts/pagelayout/PageLayout";
import TitleBigridInfo from "../../components/titleBigridInfo/TitleBigridInfo";
import AllCompanies from "./allcompanies/AllCompanies";
import WOW from "wow.js";
import SolutionSecondSec from "../solutions/solutionsecondsec/SolutionSecondSec";
import axios from "axios";
import { baseUrl, getAbout } from "../../utils/apiData";
import LoaderCard from "../../components/loaderCard/LoaderCard";

const About = () => {
  const [loader, setLoader] = useState(false);
  const [aboutPageData, setAboutPageData] = useState({});
  const [vendor, setVendor] = useState([]);

  useEffect(() => {
    const wow = new WOW();
    wow.init();
  }, []);

  const getAboutPageApi = async () => {
    setLoader(true);
    try {
      const res = await axios.get(`${baseUrl}/${getAbout}`);
      if (res?.data?.success) {
        setAboutPageData(res?.data?.data?.page);
        setVendor(res?.data?.data?.vendor);
      }
    } catch (error) {
      console.log(error);
    }
    setLoader(false);
  };

  useEffect(() => {
    getAboutPageApi();
  }, []);

  return (
    <Fragment>
      <PageLayout>
        {loader ? (
          <LoaderCard />
        ) : (
          <Fragment>
            <WhyLanding
              title={aboutPageData?.main_title || "-"}
              des={aboutPageData?.main_description || "-"}
              image={aboutPageData?.main_image}
              btnName={aboutPageData?.button_name}
            />

            <TitleBigridInfo
              category=""
              theme="light"
              title={aboutPageData?.section_1_title || "-"}
              img={aboutPageData?.section_1_image}
              danger={aboutPageData?.section_1_description}
            />

            <AllCompanies
              dataList={vendor}
              des={aboutPageData?.section_3_title || "-"}
             
            />
          </Fragment>
        )}
      </PageLayout>
    </Fragment>
  );
};

export default About;
